import React from "react";
import Intro from "../pods/Intro";
import Dashboard from "../pods/Dashboard";
import SamlCallback from "../pods/SamlCallback";

const Routes = {
  [`${__dirname}/index.html`]: () => <Intro />,
  "/": () => <Intro />,
  "/intro": () => <Intro />,
  "/dashboard": () => <Dashboard />,
  "/samlCallback": () => <SamlCallback />
};
export default Routes;